export const mailing = {
  data: function () {
    return {
      appMail: 'montessoriberdsk@gmail.com'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mailing.js